import { render, staticRenderFns } from "./IconWordpress.vue?vue&type=template&id=434e4648&"
import script from "./IconWordpress.vue?vue&type=script&lang=js&"
export * from "./IconWordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports